import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import styled from "styled-components";
import { useDebounce } from "react-use";
import { api } from "../../../api";

type AutoSuggestTextFieldComponentProps = {
  id?: string;
  className?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  mb?: string;
  value?: string;
  required?: boolean;
  autoFocus?: boolean;
  selectShopId: number;
  setSelectShopIdAction?: Dispatch<SetStateAction<number>>;
  disabled?: boolean;
};

const AutoSuggestTextFieldStyle = styled.div<{ $mb?: string }>`
  position: relative;
  border: 1px solid rgb(219, 219, 219);
  border-radius: 25px;
  margin-bottom: ${(props) => props.$mb || "0"};
  height: 50px;
  width: 100%;

  label {
    position: absolute;
    background: white;
    color: #222;
    font-size: 12px;
    top: -10px;
    left: 14px;
    padding: 0 5px;
  }

  input {
    border: none;
    border-radius: 25px;
    box-sizing: border-box;
    color: #222;
    font-size: 16px;
    outline: none;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
    height: 100%;
  }

  ul {
    position: absolute;
    background: #fafafa;
    border: 1px solid #e6e4dc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 16px;
    text-align: left;
    z-index: 9999;
    margin: 10px 0 0 0;
    padding: 0;
    width: inherit;

    li {
      padding: 4px 10px;
      list-style: none;

      &:hover {
        cursor: pointer;
        background: #f2f0e9;
      }

      small {
        display: block;
        color: #888;
        font-size: 12px;
        margin-top: 2px;
      }
    }
  }
`;

const AutoSuggestShopNameField: React.FC<
  AutoSuggestTextFieldComponentProps
> = ({
  id,
  className,
  label,
  name,
  placeholder,
  mb,
  value,
  required,
  autoFocus,
  selectShopId,
  setSelectShopIdAction,
  disabled,
}) => {
  const [shopName, setShopName] = useState<string>("");
  const [shops, setShops] = useState<
    Array<{ id: number; name: string; address: string }>
  >([]);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setShopName(value);
  }, [value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!open) setOpen(true);
    setShopName(event.target.value);
  };

  useEffect(() => {
    if (selectShopId) {
      api.getPublicShop(selectShopId).then((response) => {
        setShopName(response.data.name);
      });
    }
  }, []);

  useDebounce(
    () => {
      api.getPublicShops(1, null, shopName).then((response) => {
        setShops(
          response.data.map((shop) => {
            if (shopName === shop.name) {
              setSelectShopIdAction(shop.id);
              setOpen(false);
            } else {
              setSelectShopIdAction(null);
            }
            return {
              id: shop.id,
              name: shop.name,
              address: shop.address,
            };
          })
        );
      });
    },
    500,
    [shopName]
  );

  const SelectList = () => {
    return (
      <ul>
        {shops.map((shop) => {
          return (
            <li
              key={shop.id}
              onClick={() => {
                setShopName(shop.name);
                setSelectShopIdAction(shop.id);
                setOpen(!open);
              }}
            >
              {shop.name}
              <small>{shop.address}</small>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <AutoSuggestTextFieldStyle className={className} $mb={mb}>
      {shopName && <label htmlFor={id}>{label}</label>}
      <input
        type="text"
        id={id}
        name={name}
        placeholder={placeholder}
        onChange={handleChange}
        value={shopName}
        required={required}
        autoFocus={autoFocus}
        autoComplete="off"
        disabled={disabled}
      />
      {open && shopName && shops.length > 0 && SelectList()}
    </AutoSuggestTextFieldStyle>
  );
};

export default AutoSuggestShopNameField;
